export function addTimeZoneOffset(date: Date): Date {
    const offsetMins = -1 * date.getTimezoneOffset();
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, Math.max(0,offsetMins));
}
